import api from "./api";

async function getPaymentRequestTemplates() {
  try {
    const response = await api.get("api/paymentRequestTemplates");
    return response.data;
  } catch (error) {
    return [];
  }
}

async function getPaymentRequestTemplateById(id) {
  try {
    const response = await api.get(`api/paymentRequestTemplates/${id}`);
    return response.data;
  } catch (error) {
    return [];
  }
}

async function createPaymentRequestTemplate(
  name,
  invoicesRequested,
  paymentRequirement,
  attachPdfStatement,
  messages,
  allowCardPayment,
  paymentProfileId
) {
  try {
    const response = await api.post("api/paymentRequestTemplates", {
      name,
      invoicesRequested,
      paymentRequirement,
      attachPdfStatement,
      messages,
      allowCardPayment,
      paymentProfileId,
    });
    return response.data;
  } catch (error) {
    return [];
  }
}

async function updatePaymentRequestTemplate(
  id,
  name,
  invoicesRequested,
  paymentRequirement,
  attachPdfStatement,
  messages,
  allowCardPayment,
  paymentProfileId
) {
  try {
    const response = await api.put(`api/paymentRequestTemplates/${id}`, {
      name,
      invoicesRequested,
      paymentRequirement,
      attachPdfStatement,
      messages,
      allowCardPayment,
      paymentProfileId,
    });
    return response.data;
  } catch (error) {
    return [];
  }
}

async function deletePaymentRequestTemplate(id) {
  try {
    const response = await api.delete(`api/paymentRequestTemplates/${id}`);
    return response.data;
  } catch (error) {
    return [];
  }
}

export {
  getPaymentRequestTemplates,
  getPaymentRequestTemplateById,
  createPaymentRequestTemplate,
  updatePaymentRequestTemplate,
  deletePaymentRequestTemplate,
};
